/*eslint-disable */
// Generated from: gulp/utils/boot.tpl.js
// Set webpack public path for async loading.
__webpack_public_path__ = window.themeUrl + 'dist/';
import $ from 'jquery';
import Promise from 'promise-polyfill';
require('jquery-once');

if (!window.Promise) {
  window.Promise = Promise;
}

// Import main components.
import '9.vendors/ConsoleDummy.min';
import {$html} from '4.plugins/Globals/Globals';
import Site from 'site.js';

function initStimulPlugins($context) {
  $context.once('app-init').each(function(i, el) {
    const $el = $(el);
    new Site($el);

    // Load extra modules
    if ($el.find('[data-fitvids]').length) {
      require.ensure(['4.plugins/FitVids/FitVids'], function(a) {
        const FitVids = require('4.plugins/FitVids/FitVids').default;
        new FitVids($el);
      }, 'FitVids');
    }
    if ($el.find('[data-gmap]').length) {
      require.ensure(['4.plugins/GoogleMap/GoogleMap'], function(a) {
        const GoogleMap = require('4.plugins/GoogleMap/GoogleMap').default;
        new GoogleMap($el);
      }, 'GoogleMap');
    }
    if ($el.find('[data-lightbox]').length) {
      require.ensure(['4.plugins/Lightbox/Lightbox'], function(a) {
        const Lightbox = require('4.plugins/Lightbox/Lightbox').default;
        new Lightbox($el);
      }, 'Lightbox');
    }
    if ($el.find('[data-menu-toggle]').length) {
      require.ensure(['4.plugins/MenuToggle/MenuToggle'], function(a) {
        const MenuToggle = require('4.plugins/MenuToggle/MenuToggle').default;
        new MenuToggle($el);
      }, 'MenuToggle');
    }
    if ($el.find('[data-parallax]').length) {
      require.ensure(['4.plugins/Parallax/Parallax'], function(a) {
        const Parallax = require('4.plugins/Parallax/Parallax').default;
        new Parallax($el);
      }, 'Parallax');
    }
    if ($el.find('[data-slideshow]').length) {
      require.ensure(['4.plugins/Slideshow/Slideshow'], function(a) {
        const Slideshow = require('4.plugins/Slideshow/Slideshow').default;
        new Slideshow($el);
      }, 'Slideshow');
    }
    if ($el.find('[data-smooth-anchors]').length) {
      require.ensure(['4.plugins/SmoothAnchors/SmoothAnchors'], function(a) {
        const SmoothAnchors = require('4.plugins/SmoothAnchors/SmoothAnchors').default;
        new SmoothAnchors($el);
      }, 'SmoothAnchors');
    }
    if ($el.find('[data-sticky-header]').length) {
      require.ensure(['4.plugins/StickyHeader/StickyHeader'], function(a) {
        const StickyHeader = require('4.plugins/StickyHeader/StickyHeader').default;
        new StickyHeader($el);
      }, 'StickyHeader');
    }
    if ($el.find('[data-tooltip]').length) {
      require.ensure(['4.plugins/Tooltip/Tooltip'], function(a) {
        const Tooltip = require('4.plugins/Tooltip/Tooltip').default;
        new Tooltip($el);
      }, 'Tooltip');
    }
    if ($el.find('[data-animation]').length) {
      require.ensure(['4.plugins/ScrollAnimation/ScrollAnimation'], function(a) {
        const ScrollAnimation = require('4.plugins/ScrollAnimation/ScrollAnimation').default;
        new ScrollAnimation($el);
      }, 'ScrollAnimation');
    }
    });
};

initStimulPlugins($html);

// Make function globally available.
window.initStimulPlugins = initStimulPlugins;



// WEBPACK FOOTER //
// ./boot.js